export const itemSubTypes = Object.freeze({
  Unset: 0,
  ValidateInstrumentsOrPilotTest: 1,
  ConductResearch: 2,
  VirtualLibraryThesisPublication: 7,
  ActionResearch: 8,
});

export const ItemSubTypesDescription = Object.freeze({
  [itemSubTypes.Unset]: 'Unset',
  [itemSubTypes.ValidateInstrumentsOrPilotTest]:
    'Validar Instrumentos o Prueba piloto',
  [itemSubTypes.ConductResearch]: 'Realizar Investigacion',
  [itemSubTypes.VirtualLibraryThesisPublication]:
    'Publicación de Tesis Biblioteca Virtual',
  [itemSubTypes.ActionResearch]: 'Investigación en Acción',
});
